
import { defineComponent, PropType } from 'vue';

// Services & types
import { Item } from '~/services/types/import';
import { itemNeedAttentionNoRecursion } from '~/utils/candidate/ProfileImportHelper';

export default defineComponent({
    name: 'ImportSectionItems',
    props: {
        items: {
            type: Array as PropType<Item[]>,
            required: true,
        },
        child: Boolean,
        child2: Boolean,
        resultViewOnlyMode: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        // This is a recursive component, so it references itself
        ItemList: () => import('./ImportSectionItems.vue'),
    },
    methods: {
        itemNeedAttention(item: Item): boolean {
            return itemNeedAttentionNoRecursion(item);
        },
        description(item: Item): string {
            return String(
                this.$t(`profile.import.results.${item.descriptionKey}`, item.descriptionValues)
            );
        },
    },
});
